export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Soft%20minimalist%20product%20photography%20flat%20lay%20with%20pastel%20cream%20and%20sage%20green%20aesthetic%20background%20featuring%20elegant%20fashion%20accessories%20and%20sneakers%20arranged%20artfully%20on%20light%20linen%20texture%20surface%20with%20warm%20natural%20daylight%20casting%20gentle%20shadows%20clean%20composition%20editorial%20style%20high%20end%20look&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="CSSBuy Spreadsheet Directory Background"
        className="absolute inset-0 w-full h-full object-cover object-top"
        loading="eager"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/45 via-foreground-950/30 to-foreground-950/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <span className="inline-block px-4 py-1.5 bg-background-50/20 backdrop-blur-sm border border-background-50/30 rounded-full text-xs md:text-sm font-medium text-background-50 tracking-wide mb-5 whitespace-nowrap">
          2026 Updated &bull; 3000+ Verified Links
        </span>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight max-w-4xl">
          CSSBuy Spreadsheet
          <br />
          <span className="text-primary-300">The Largest Free Directory</span>
        </h1>

        <p className="mt-5 md:mt-6 text-sm md:text-base text-background-50/80 max-w-2xl leading-relaxed">
          Discover thousands of carefully organized spreadsheet links, updated buying guides, trusted sellers, shipping tips, and quality-checked recommendations — all in one place.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-md hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            Browse CSSBuy Sheet
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 border-2 border-background-50/40 text-background-50 font-semibold text-sm rounded-md hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer"
          >
            Buy It Now
            <i className="ri-arrow-right-up-line ml-2"></i>
          </a>
        </div>

        <div className="mt-10 flex items-center gap-3 text-background-50/60 text-xs">
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-checkbox-circle-fill text-primary-400 text-sm w-4 h-4 flex items-center justify-center"></i> Updated Daily
          </span>
          <span className="w-1 h-1 rounded-full bg-background-50/30"></span>
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-shield-check-fill text-primary-400 text-sm w-4 h-4 flex items-center justify-center"></i> Verified Sellers
          </span>
          <span className="w-1 h-1 rounded-full bg-background-50/30"></span>
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-flashlight-fill text-primary-400 text-sm w-4 h-4 flex items-center justify-center"></i> 100% Free
          </span>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <a href="#categories" className="flex flex-col items-center gap-1 text-background-50/60 hover:text-background-50/90 transition-colors cursor-pointer">
          <span className="text-xs font-medium whitespace-nowrap">Explore Categories</span>
          <i className="ri-arrow-down-s-line text-lg animate-bounce"></i>
        </a>
      </div>
    </section>
  );
}